var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"hera-subheader",class:[("hera-subheader--" + _vm.variant)]},[_c('TextBlock',_vm._b({},'TextBlock',{
      size: 1.125,
      variant: _vm.isMuted ? 'muted' : 'primary',
      lineHeight: 1.333334,
      text: _vm.text,
      tag: _vm.tag,
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }